import type { PostAuthOptions } from 'types';

export function getBrowser(userAgent: string | null) {
  const match = userAgent?.match(/firefox|chrome|safari|instagram|msie/i);

  if (!match) return 'unknown';

  const [browser] = match;

  return browser!.toLowerCase();
}

export function isAppleMobileDevice(userAgent: string | null) {
  if (!userAgent) return false;

  return /iPhone|iPad/i.test(userAgent);
}

export function isInAppBrowser(userAgent: string = '') {
  return /instagram|fban|fbav|twitter/i.test(userAgent);
}

export function storeNotificationData(postAuthOptions: PostAuthOptions) {
  const DAY_IN_MS = 1000 * 60 * 60 * 24;

  localStorage.setItem(
    'notificationData',
    JSON.stringify({
      expires: Date.now() + DAY_IN_MS,
      legacyProductId: postAuthOptions.legacyProductId,
      productId: postAuthOptions.productId,
      productName: postAuthOptions.productName,
      sizes: postAuthOptions.sizes
    })
  );
}
